import {FeatureFlags} from "../../contexts/UserContext";
import {get, isEmpty} from "lodash";
import {useMemo} from "react";

const utmToFlagMap: Record<string, string> = {
  promotional: "promotional_flow_test",
  micro_down_payment: "abtest_micro_down_payment",
  old_debt_highca: "abtest_hardship_for_non_converting_accounts",
  hardship_intro: "abtest_hardship_for_low_debra_scores",
  hardship_funnel: "abtest_hardship_for_low_debra_scores",
  not_operating: "abtest_hardship_for_low_ca_scores",
};

interface IGetIsCampaignExpired {
  utmCampaign: string | null;
  featureFlags?: FeatureFlags;
}

const useIsCampaignExpired = ({utmCampaign, featureFlags}: IGetIsCampaignExpired) => {
  return useMemo(() => {
    if (!utmCampaign || isEmpty(featureFlags)) {
      return false;
    }

    const utmKey = Object.keys(utmToFlagMap).find((key) => utmCampaign.toLowerCase().startsWith(key));

    const featureFlagName = utmKey ? utmToFlagMap[utmKey] : "";
    const featureFlag = get(featureFlags, featureFlagName);

    return featureFlag ? featureFlag.expired : false;
  }, [utmCampaign, featureFlags]);
};

export {useIsCampaignExpired};
